import React, {useEffect, useState} from 'react'
import {Alert, Spin} from 'antd'
import {apiGetRequest} from '../http/http'
import ScoreResult360 from './OA/Score/ScoreResult360'
import GuanyuanPage from './GuanyuanPage/GuanyuanPage'

// 每张报表使用自己的 OA 菜单权限；未列入的报表保持当前关闭状态。
const guanyuanAccessChecks = {
    '1804082748401258496': () => apiGetRequest('/lechun-baseservice/sso/checkGuanyuanReportAccess?ssoId=1804082748401258496'),
    '1869592647067373568': () => apiGetRequest('/lechun-baseservice/sso/checkGuanyuanReportAccess?ssoId=1869592647067373568')
}

// 校验完成前不挂载业务页面；每次进入页面均由后端检查当前登录用户。
export function ReportAccessGate({checkAccess, children}) {
    const [access, setAccess] = useState('checking')
    useEffect(() => {
        let active = true
        Promise.resolve().then(checkAccess).then(allowed => {
            if (active) setAccess(allowed === true ? 'allowed' : 'denied')
        }).catch(() => {
            if (active) setAccess('denied')
        })
        return () => { active = false }
    }, [checkAccess])
    if (access === 'checking') return <Spin tip="正在校验访问权限" />
    if (access !== 'allowed') return <Alert type="error" showIcon message="无法访问此报表" description="权限校验未通过，请联系管理员确认授权后重试。" />
    return children
}

const check360Access = () => apiGetRequest('/lechun-baseservice/eval/checkResultAccess')

export function ProtectedScoreResult360(props) {
    return <ReportAccessGate checkAccess={check360Access}><ScoreResult360 {...props} /></ReportAccessGate>
}

export function ProtectedGuanyuanReport(props) {
    const search = props.location ? props.location.search : window.location.search
    const ids = new URLSearchParams(search).getAll('id')
    if (ids.length !== 1 || !Object.prototype.hasOwnProperty.call(guanyuanAccessChecks, ids[0])) {
        return <Alert type="error" showIcon message="页面暂未开放" />
    }
    // 切换报表时重置授权状态，不能复用上一张报表已通过的校验。
    return <ReportAccessGate key={ids[0]} checkAccess={guanyuanAccessChecks[ids[0]]}><GuanyuanPage {...props} /></ReportAccessGate>
}
